export default __webpack_public_path__ + "static/media/denied.b697c856.svg";